import React, {useCallback, useEffect, useState} from 'react'
import {Stack, Typography} from '@mui/material'
import {colors} from '@/constants'
import ReferralsService from '@/services/api/Referrals'
import {AxiosResponseReferralsInterface} from '@/types/types'
import SimpleLoader from '@/components/UI/simpleLoader'
import NotReferrralSystem from '@/components/Modals/Profile/ReferralSystem/NotReferrralSystem'
import {errorCodeHandler} from '@/helpers/localErrorCodeHandler'
import TransCustom from '@/components/UI/i18next'
import {ReactComponent as CopyIcon} from '@/assets/svgs/CopyIcon.svg'
import useCopyToClipboard from '@/hooks/useCopyToClipboard'
import {getBaseUrl} from '@/helpers/GetBaseUrl'
import ReferralEnterForm from '@/components/Modals/Profile/ReferralSystem/ReferralEnterForm'

// В профиле остаётся только реферальная ссылка.
// Вся работа со структурой перенесена в кабинет 4ММ → My masters.
// Исключение: переход по ссылке-приглашению (code) — форма ввода кода нужна
// обычным игрокам, а 4ММ доступен только маркетмейкерам.
const Index = ({code}: {code?: string}) => {
  const {copyToClipboard} = useCopyToClipboard()
  const [isLoad, setIsLoad] = useState(false)
  const [myStructures, setMyStructures] = useState<
    AxiosResponseReferralsInterface[]
  >([])

  const getReferrals = useCallback(async () => {
    try {
      const response = await ReferralsService.getReferrals()
      if (response.status === 200) {
        setMyStructures(response.data.filter((item) => item.is_root))
      }
    } catch (e) {
      errorCodeHandler(e)
    } finally {
      setIsLoad(true)
    }
  }, [])

  useEffect(() => {
    void getReferrals()
  }, [])

  const referralLink = (rootNumber: number) =>
    `${getBaseUrl()}?referral=${rootNumber}`

  return (
    <Stack gap="30px" width="80%" height="100%" position="relative">
      <TransCustom i18nKey="1249" variant="h1" color={colors.yellow} />
      {code ? (
        <ReferralEnterForm code={code} getExternalReferrals={getReferrals} />
      ) : !isLoad ? (
        <SimpleLoader isLoad={true} />
      ) : myStructures.length === 0 ? (
        <NotReferrralSystem />
      ) : (
        <Stack gap="24px">
          {myStructures.map((structure) => (
            <Stack key={structure.root_number} gap="6px">
              <Stack direction="row" gap="5px" alignItems="center">
                <TransCustom i18nKey="1381" variant="body2" />
                <Typography fontSize="20px" style={{wordBreak: 'break-all'}}>
                  :&nbsp;{referralLink(structure.root_number)}
                </Typography>
                <CopyIcon
                  className="svg-first-color-fill pointer"
                  onClick={() =>
                    copyToClipboard(referralLink(structure.root_number))
                  }
                />
              </Stack>
              <TransCustom
                i18nKey="1396"
                params={{param1: structure.root_number}}
                variant="body2"
                color={colors.gray}
              />
            </Stack>
          ))}
        </Stack>
      )}
    </Stack>
  )
}

export default Index
